module.exports = __webpack_public_path__ + "img/Tallos404.5615f5d8.svg";